export const staleTime = 900000;    // 10 mins cache
export const gcTime = 1800000;      // 15 mins delete cache
export const globalSupportEmail = "hello@fourcolorstech.com";

const ROLE_PRECEDENCE = ['Admin', 'Internal Admin', 'Internal Manager', 'Internal User'];

export function getHighestPrecedenceRole(roles) {
    if (!Array.isArray(roles)) roles = String(roles).split(',').map(r => r.trim());
    for (const role of ROLE_PRECEDENCE) {
        if (roles.includes(role)) return role;
    }
    return roles[0] || '';
}